import React from 'react';
import './header.css';
import { SeIcon } from '@se/web-ui-react';
import { logoutUser } from '../../api/logoutApi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import handle_toast  from '../../genericFunctions/toast_Handler';

const Header = ({ title, navItem, subnavtitle }) => {

    const userName = sessionStorage.getItem('User');

    const dispatch = useDispatch();  
    const navigate = useNavigate();
  
    const handleLogout = async () => {
        try{            
            await logoutUser(dispatch);
            navigate('/logout')
        }
        catch(error){            
            handle_toast(error)
            navigate('/logout')
        }
    }
    
    return (
        <div data-testid='gcadheader' className='gcadheader'>
            <se-header domain="none">
                <se-sidemenu></se-sidemenu>
                <label className='matterPortal'>{title}</label>
                <label data-testid='navigationitem' className='navitem'>{navItem}</label>
                <label data-testid='subnavigationitem' className='subnavtitle'>{subnavtitle}</label>
                <div slot="end">
                    <SeIcon className='notification'>action_notification_default</SeIcon>
                    <se-dropdown alignment="right">
                        <se-button slot="trigger" option="inherit" icon="user_standard" icon-color="primary">          
                            <div className='dropdownmargin'>
                                <label className='usernametext'>{userName}</label>
                                <br />
                            </div>
                        </se-button>
                        <se-list option="dropdown" style={{maxWidth: '110px',minHeight: '32px' }} >  
                        <se-list-item
                            onClick={() => handleLogout()}
                            item="Logout"></se-list-item>  
                            </se-list>                         
        
                    </se-dropdown>
                </div>
            </se-header>
        </div>
    );
};

export default Header;